import {PanelExportContextProvider} from '@wandb/weave/components/Panel2/PanelExportContext';
import React, {useEffect} from 'react';

import {trackPageViewed} from '../util/navigation';
import ProjectArtifactTypes from './ProjectArtifactTypes';

interface ProjectArtifactsTabProps {
  entityName: string;
  projectName: string;
  artifactTypeName?: string;
  artifactCollectionName?: string;
  artifactCollectionView?: string;
  artifactCommitHash?: string;
  artifactTab?: string;
  filePath?: string;
  history: any;
}

const ProjectArtifactsTab = (props: ProjectArtifactsTabProps) => {
  const compareArtifact = React.useMemo(() => {
    const urlHash = props.history.location.hash.slice(1) ?? '';
    let [compareIdentifier, compareSequenceName] = urlHash.split('$');
    compareIdentifier =
      compareIdentifier != null
        ? decodeURIComponent(compareIdentifier)
        : compareIdentifier;
    compareSequenceName =
      compareSequenceName != null
        ? decodeURIComponent(compareSequenceName)
        : compareSequenceName;
    return compareIdentifier !== ''
      ? {
          artifactCollectionName:
            compareSequenceName ?? props.artifactCollectionName,
          membershipIdentifier: compareIdentifier,
        }
      : undefined;
  }, [props.artifactCollectionName, props.history.location.hash]);
  return (
    <ProjectArtifactTypes
      {...props}
      artifactTypeName={
        props.artifactTypeName != null
          ? decodeURIComponent(props.artifactTypeName)
          : props.artifactTypeName
      }
      artifactCollectionName={
        props.artifactCollectionName != null
          ? decodeURIComponent(props.artifactCollectionName)
          : props.artifactCollectionName
      }
      membershipIdentifier={props.artifactCommitHash}
      compareArtifact={compareArtifact}
    />
  );
};

const ProjectArtifactsTabWithClass = (props: ProjectArtifactsTabProps) => {
  // for page view tracking
  useEffect(() => {
    trackPageViewed('Artifacts');
  }, []);

  return (
    <div className="artifacts">
      <PanelExportContextProvider>
        <ProjectArtifactsTab {...props} />
      </PanelExportContextProvider>
    </div>
  );
};

export default ProjectArtifactsTabWithClass;
